import { Controller } from "stimulus"

export default class extends Controller {
    connect() {
        this.toggleTransferFields()
    }

    toggleTransferFields() {
        const allocationType = this.element.querySelector('select[name*="allocation_type"]')
        const relatedFundField = document.getElementById('related-fund-field')
        
        if (allocationType && relatedFundField) {
            if (allocationType.value === 'transfer') {
                relatedFundField.classList.remove('hidden')
            } else {
                relatedFundField.classList.add('hidden')
            }
        }
    }
}